import axios from 'axios';
import { api, headers } from '../../app/conf';
import { makeQuery } from '../../shared/helpers/commons';

export const getExportIdService = async (filters, type, token) => {
  try {
    const response = await axios({
      method: 'get',
      url: `${api}/tickets/${type}/exports?tz=${new Date().getTimezoneOffset()}&${makeQuery(filters)}`,
      headers: {
        ...headers,
        'X-Access-Token': token,
      },
      responseType: 'blob', 
    });

    const contentDisposition = response.headers['content-disposition'];
    let filename = 'reporte.xlsx';
    if (contentDisposition && contentDisposition.includes('filename=')) {
      filename = contentDisposition
        .split('filename=')[1]
        .trim()
        .replace(/["']/g, '');
    }

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();

    return { success: true };
  } catch (error) {
    throw error; 
  }
};

export const getTickets = (filters, type, token) =>
    axios({
        method: 'get',
        url: `${api}/tickets/${type}?${makeQuery(filters)}`,
        headers: {
            ...headers,
            'X-Access-Token': token
        }
    });

export const postTicket = (ticket, type, token) =>
    axios({
        method: 'post',
        url: `${api}/tickets/${type}`,
        headers: {
            ...headers,
            'X-Access-Token': token,
            expireResponseWithKey: `${api}/tickets`
        },
        data: ticket
    });

export const putTicket = (ticket, type, token) =>
    axios({
        method: 'put',
        url: `${api}/tickets/${type}/${ticket._id}`,
        headers: {
            ...headers,
            'X-Access-Token': token,
            expireResponseWithKey: `${api}/tickets`
        },
        data: ticket
    });

    export const getCompanyPlans = (companyId, token) =>
        axios({
          method: 'get',
          url: `${api}/companies/${companyId}/plans`,
          headers: {
            ...headers,
            'X-Access-Token': token,
          }
        });

export const getNonInstallationReasons = (token) =>
    axios({
        method: 'get',
        url: `${api}/non-installation-reasons?active=true`,
        headers: {
            ...headers,
            'X-Access-Token': token
        }
    });
      